import { render, staticRenderFns } from "./select-good-list.vue?vue&type=template&id=51c299b9&scoped=true"
import script from "./select-good-list.vue?vue&type=script&lang=js"
export * from "./select-good-list.vue?vue&type=script&lang=js"
import style0 from "./select-good-list.vue?vue&type=style&index=0&id=51c299b9&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51c299b9",
  null
  
)

export default component.exports